import React from 'react';

import { Briefcase, Card, Personalcard } from 'iconsax-react';

import { i18n } from 'third-party';

import {
  organizationListUrl,
  userPayeeListUrl,
  userPaymentListUrl,
} from 'constants/url';

import { MenuType } from 'types/app';

import { palette } from 'styles/theme';

export const UserMenu = (): MenuType[] => [
  {
    items: [
      {
        url: () => userPaymentListUrl(),
        text: i18n.t('menu.myPayments'),
        id: 'menu-payments',
        icon: <Card variant="TwoTone" color={palette.whiteText} size="20" />,
      },
      {
        url: () => userPayeeListUrl(),
        text: i18n.t('menu.userPayees'),
        id: 'menu-payee',
        icon: (
          <Personalcard variant="TwoTone" color={palette.whiteText} size="20" />
        ),
      },
      {
        id: 'menu-organization',
        url: () => organizationListUrl(),
        text: 'Organization',
        icon: (
          <Briefcase variant="TwoTone" color={palette.whiteText} size="20" />
        ),
      },
    ],
  },
];
